import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineCardComponent } from './timeline-card.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ TimelineCardComponent ],
    declarations: [ TimelineCardComponent ],
})
export class TimelineCardModule {}
